import React from "react";
import { Link, Icon } from "@telia/teddy";

interface BackLinkProps {
    href?: string;
    text: string;
}

/** @deprecated: unused? */
const BackLink: React.FC<BackLinkProps> = ({ href, text }) => (
    <Link
        variant="standalone"
        onClick={href ? undefined : () => window.history.back()}
        href={href || "javascript:void(0)"}
    >
        <Icon name="arrow-left" />
        {text}
    </Link>
);

export default BackLink;
